export const fetchConfig = async () => {
  try {
    const response = await fetch("/config.json");
    if (response.ok) {
      const config = await response.json();
      return config;
    } else {
      console.warn("Failed to load config.json.");
      return "";
    }
  } catch (error) {
    console.error("Error during fetching config:", error);
    return "";
  }
};
